/**
 * Copyright (c) Microsoft. All rights reserved.
 */

export type RenderPhase = 'calculateInitialTokenBounds' | 'calculatePaddedTokenBounds' | 'ready';

export type RenderPhaseAction = { actionType: 'next' | 'invalidate' | 'invalidatePadding' };

/*
The Labeler layout algorithm goes through two phases to render the tokens, calculate multi-line
labels, add padding to tokens and calculate the final tokens padding to layout the multi-line labels.

+------------------------+        +-------------------------------+       +---------+
| Calculate token rects  |------->| Calculate padded token rects  |------>|  Ready  |
+------------------------+        +-------------------------------+       +---------+
            ^                                     ^                            | |
            |                                     |                            | |
            |                         +------------------------+               | |
            |                         |  Any change to tokens  |<--------------+ |
            |                         |        paddings        |                 |
+---------------------------+         +------------------------+                 |
| Tokens get redistributed  |                                                    |
| among lines               |<---------------------------------------------------+                                                    |
+---------------------------+
*/
export const renderPhaseReducer = (state: RenderPhase, action: RenderPhaseAction): RenderPhase => {
    switch (action.actionType) {
        case 'next': {
            switch (state) {
                case 'calculateInitialTokenBounds':
                    return 'calculatePaddedTokenBounds';
                case 'calculatePaddedTokenBounds':
                    return 'ready';
                case 'ready':
                    return state;
                default:
                    return state;
            }
        }
        case 'invalidatePadding': {
            return state === 'ready' ? 'calculatePaddedTokenBounds' : state;
        }
        case 'invalidate': {
            return state === 'ready' ? 'calculateInitialTokenBounds' : state;
        }

        default:
            return state;
    }
};
